export function formatStatusLabel(status: string): string {
  if (!status) return "Unknown";
  const spaced = status.replace(/_/g, " ");
  return spaced.charAt(0).toUpperCase() + spaced.slice(1);
}
